import {jQuery as $, lodash as _} from 'lib/shim';
import {BREAKPOINT_DESKTOP, BREAKPOINT_TABLET} from '../../../javascript/defines';



const NAME = 'organism-teaser-3-columns',
	SELECTOR = '.'+NAME;



class OrganismTeaser3Columns {

	constructor(app, $element){
		if( !$.isSet($element.dataDuo('primed')) ){
			$element.dataDuo('primed', true);

			this._app = app;
			this._id = $.randomUuid(true);
			this._$element = $element;

			this._$slider = this._$element.find('.slider').first();
			this._$teaserContent = this._$element.find('.slider-content .teaser-content').first();

			this._prime();
		}

		return $element;
	}



	_prime(){
		let setContent = (slick, currentSlide) => {
			let $slide = $(slick.$slides[currentSlide]),
				$content = $slide.find('.teaser-content');

			this._$teaserContent.addClass('active');
			this._$teaserContent.html($content.html());
		};

		this._$slider.slick({
			dots : true,
			arrows : false,
			speed : 500,
			slidesToShow : 1,
			infinite : false,
			mobileFirst : true,
			responsive : [
				{
					breakpoint: BREAKPOINT_TABLET - 1,
					settings: {
						slidesToShow: 3,
						dots: false
					}
				},
				{
					breakpoint: BREAKPOINT_DESKTOP + 1,
					settings: {
						slidesToShow: 3,
					}
				}
			]
		})
		.on('init', (ev, slick) => setContent(slick, 0))
		.on('reInit', (ev, slick) => setContent(slick, 0))
		.on('afterChange', (ev, slick, currentSlide) => setContent(slick, currentSlide))
		.on('beforeChange', () => this._$teaserContent.removeClass('active'))
		.slick('slickGoTo', 0);

		this._$element.removeClass('cloaked');
	}
}



export function init(app){
	let $elements = $();

	$(SELECTOR).each(function(){
		let $this = $(this);

		$elements = $elements.add(new OrganismTeaser3Columns(app, $this));
	});

	return $elements;
}
